import { authOperations } from "./authOperations";
import jwt from "jwt-decode";

function createServiceCallWithReturn(actionSuccess, actionError) {
    return async function serviceCall(dispatch, serviceMethod, ...args) {
        let callResult = undefined;

        try {
            callResult = await serviceMethod(...args);
        } catch (e) {
            console.log("OperationsFactory catch");
            console.log(e);
            throw e;
        }

        if (!!callResult) {
            dispatch(actionSuccess(callResult));
        } else {
            dispatch(actionError("error"));
        }
    };
}

function createServiceCallNoReturn(actionSuccess, actionError) {
    return async function serviceCallNoReturn(dispatch, serviceMethod, ...args) {
        await serviceMethod(...args);
        dispatch(actionSuccess(null));
    };
}

function createServiceCallWithTokenRefresh(
    serviceCallFactory,
    actionSuccess,
    actionError
) {
    return async function serviceCallWithTokenRefresh(
        dispatch,
        serviceMethod,
        ...args
    ) {
        var isTokenExpired = checkTokenExpireDate();
        if (isTokenExpired) {
            await authOperations.refreshToken(dispatch);
            authOperations.awaitTokenRefreshAsync(async () => {
                try {
                    await serviceCall(
                        dispatch,
                        serviceMethod,
                        authOperations.getToken(),
                        ...args
                    );
                } catch (e2) {
                    console.log("PROTECTED OPERATIONS: EXCEPTION SIGNOUT")
                    dispatch(actionError(e2.message));
                    window.location.href = "#/signout";
                }
            });
        }

        const serviceCall = serviceCallFactory(actionSuccess, actionError);
        try {
            await serviceCall(
                dispatch,
                serviceMethod,
                authOperations.getToken(),
                ...args
            );
        } catch (e1) {
            console.log("OperationsFactory catch");
            console.log(e1);
            if (e1.message == 401) {
                await authOperations.refreshToken(dispatch);
                authOperations.awaitTokenRefreshAsync(async () => {
                    try {
                        await serviceCall(
                            dispatch,
                            serviceMethod,
                            authOperations.getToken(),
                            ...args
                        );
                    } catch (e2) {
                        dispatch(actionError(e2.message));
                        window.location.href = "#/signout";
                    }
                });
            } else {
                dispatch(actionError(e1.message));
            }
        }
    };
}

const createFetchAllMethod = function (actions, serviceMethod) {
    return function fetchAll(filter = null) {
        return (dispatch) => {
            authOperations.awaitTokenRefresh(() => {
                dispatch(actions.fetchAllPending());
                dispatch(actions.setFilter(filter));

                createServiceCallWithTokenRefresh(
                    createServiceCallWithReturn,
                    actions.fetchAllSuccess,
                    actions.fetchAllError
                )(dispatch, serviceMethod, filter).then();
            });
        };
    };
};

const createGenericFetchMethod = function (
    fetchPendingFunc,
    fetchSuccessFunc,
    fetchErrorFunc,
    serviceMethod
) {
    return function fetch(id, opt = null) {
        return (dispatch) => {
            authOperations.awaitTokenRefresh(() => {
                dispatch(fetchPendingFunc());
                // eslint-disable-next-line
                if (id == "0") {
                    dispatch(fetchSuccessFunc(null));
                    return;
                }
                createServiceCallWithTokenRefresh(
                    createServiceCallWithReturn,
                    fetchSuccessFunc,
                    fetchErrorFunc
                )(dispatch, serviceMethod, id, opt).then();
            });
        };
    };
};

const createFetchMethod = function (actions, serviceMethod) {
    return createGenericFetchMethod(
        actions.fetchPending,
        actions.fetchSuccess,
        actions.fetchError,
        serviceMethod
    );
};

const createFetchStatusMethod = function (actions, serviceMethod) {
    return function fetch() {
        return (dispatch) => {
            authOperations.awaitTokenRefresh(() => {
                dispatch(actions.fetchPending());
                createServiceCallWithTokenRefresh(
                    createServiceCallWithReturn,
                    actions.fetchSuccess,
                    actions.fetchError
                )(dispatch, serviceMethod).then();
            });
        };
    };
};

const createFetchHistoryMethod = function (actions, serviceMethod) {
    return function fetchHistory(id, opt = null) {
        return (dispatch) => {
            authOperations.awaitTokenRefresh(() => {
                dispatch(actions.fetchHistoryPending());

                createServiceCallWithTokenRefresh(
                    createServiceCallWithReturn,
                    actions.fetchHistorySuccess,
                    actions.fetchHistoryError
                )(dispatch, serviceMethod, id, opt).then();
            });
        };
    };
};

const createUpdateOrCreateMethod = function (actions, serviceMethod) {
    return function update(payload) {
        return (dispatch) => {
            authOperations.awaitTokenRefresh(() => {
                dispatch(actions.fetchPending());
                dispatch(actions.editPending());

                createServiceCallWithTokenRefresh(
                    createServiceCallWithReturn,
                    actions.fetchSuccess,
                    actions.fetchError
                )(dispatch, serviceMethod, payload).then();
            });
        };
    };
};

const createUpdateOrCreateAllMethod = function (actions, serviceMethod) {
    return function update(payload) {
        return (dispatch) => {
            authOperations.awaitTokenRefresh(() => {
                dispatch(actions.fetchAllPending());
                dispatch(actions.editPending());

                createServiceCallWithTokenRefresh(
                    createServiceCallWithReturn,
                    actions.fetchAllSuccess,
                    actions.fetchAllError
                )(dispatch, serviceMethod, payload).then();
            });
        };
    };
};

const createDeleteMethod = function (actions, serviceMethod) {
    return function del(id) {
        return (dispatch) => {
            dispatch(actions.fetchPending());

            createServiceCallWithTokenRefresh(
                createServiceCallNoReturn,
                actions.fetchSuccess,
                actions.fetchError
            )(dispatch, serviceMethod, id).then();
        };
    };
};

const createCopyMethod = function (actions, serviceMethod) {
    // return function copy(payload) {
    //   console.log(payload);
    //   return (dispatch) => {
    //     dispatch(actions.copyPending());

    //     createServiceCallWithTokenRefresh(
    //       createServiceCallNoReturn,
    //       actions.copySuccess,
    //       actions.copyError
    //     )(dispatch, serviceMethod, payload).then();
    //   };
    // };

    return function copy(payload) {
        return (dispatch) => {
            authOperations.awaitTokenRefresh(() => {
                dispatch(actions.copyPending());

                createServiceCallWithTokenRefresh(
                    createServiceCallWithReturn,
                    actions.copySuccess,
                    actions.copyError
                )(dispatch, serviceMethod, payload).then();
            });
        };
    };
};

const checkTokenExpireDate = () => {
    let sessionTime = sessionStorage.getItem("sessionTime") ?? localStorage.getItem("sessionTime");
    if (!!sessionTime && sessionTime.exp * 1000 < Date.now()) {
        return true;
    }
    return false;
};

export const OperationsFactory = {
    createGenericFetchMethod,
    createFetchAllMethod,
    createFetchMethod,
    createFetchStatusMethod,
    createFetchHistoryMethod,
    createUpdateOrCreateMethod,
    createUpdateOrCreateAllMethod,
    createDeleteMethod,
    createCopyMethod,
};
